import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import Model from 'src/storage/base';

class QRCodeModel extends Model {
  id = 'QRCodeModel';

  defaultState = () => ({
    shortened: {}
  });

  apiConfig = {
    shorten: {
      url: 'url/shorten',
      validation: { url: 'string' }
    },
    // One-time code (short-lived) that lets the mobile app sign in. Never put the sid in a QR/URL.
    handoff: {
      url: 'auth/handoff',
      validation: { action: 'string' }
    }
  };

  getHandoffCode = (action, cb) => {
    this.api('handoff', { action }, (err, data, success) => {
      if (success && data?.ok && data.code) {
        cb(null, data);
      } else {
        cb(err || new Error('handoff failed'));
      }
    });
  };

  getShortened = (url) => {
    return this.state.shortened[url];
  };

  shorten = (url, cb) => {
    if (!url) return;
    let shortened = this.getShortened(url);
    if (shortened) {
      typeof cb === 'function' && cb(null, shortened, true);
      return shortened;
    }
    this.api('shorten', { url }, (err, data, success) => {
      let fullUrl = null;
      if (success && data?.shortCode) {
        fullUrl = window.location.origin + '/go/' + data.shortCode;
        let shortened = { ...this.state.shortened, [url]: fullUrl };
        this.setState({ shortened });
      }
      typeof cb === 'function' && cb(err, fullUrl, success);
    });
  };
}
const model = new QRCodeModel();

const REFRESH_MARGIN_SECONDS = 30;

// `handoff`: the QR signs the scanning phone into the app. It uses a one-time code that
// expires quickly, so the code is refreshed before it expires.
const QRCode = ({ action, skipShorten = false, handoff = false, size = 256, className, children }) => {
  const [shortenedState, setShortenedState] = useState({ value: null, url: null });
  const [handoffCode, setHandoffCode] = useState(null);

  useEffect(() => {
    if (!handoff) return undefined;

    let ignore = false;
    let timer = null;
    const load = () => {
      model.getHandoffCode(action, (err, data) => {
        if (ignore) return;
        if (err) {
          setHandoffCode(null);
          return;
        }
        setHandoffCode(data.code);
        const wait = Math.max(10, (data.expiresIn || 60) - REFRESH_MARGIN_SECONDS) * 1000;
        timer = setTimeout(load, wait);
      });
    };
    load();

    return () => {
      ignore = true;
      clearTimeout(timer);
    };
  }, [handoff, action]);

  let domain = 'https://lifeapp.com';
  // domain = 'http://192.168.68.68:4001';

  let value = `${domain}/api/mobile?qr=1&action=${action}`;
  if (handoff && handoffCode) {
    value += `&hcode=` + encodeURIComponent(handoffCode);
  }

  const cachedShortenedUrl = skipShorten ? null : model.getShortened(value) || null;
  const shortenedUrl =
    skipShorten ? null : cachedShortenedUrl || (shortenedState.value === value ? shortenedState.url : null);

  useEffect(() => {
    if (skipShorten || cachedShortenedUrl) return undefined;

    let ignore = false;
    model.shorten(value, (err, shortUrl, success) => {
      if (ignore) return;

      if (success && shortUrl) {
        setShortenedState({ value, url: shortUrl });
      }
    });

    return () => {
      ignore = true;
    };
  }, [cachedShortenedUrl, skipShorten, value]);

  if (handoff && !handoffCode) {
    return null;
  }

  if (!shortenedUrl && !skipShorten) {
    return null;
  }

  const qrValue = shortenedUrl || value;

  return (
    <div className={className}>
      <QRCodeSVG
        value={qrValue}
        size={size}
        // level={'H'}
        // includeMargin={true}
      />
      {children}
    </div>
  );
};

export default QRCode;
